import React from "react";

class EmailField extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="form-field">
                <label>
                    Email:&nbsp;
                    <input type="email" value={this.props.value} onChange={this.props.onChange} />
                </label>
            </div>
        )
    }
}

export default EmailField;
